export function replaceFilter () {
	return (value, symbol, newValue) => {
		if (!value) {
			return value;
		} else if (typeof value !== 'string') {
			value = value.toString();
		}
		return value.replace(symbol, newValue);
	};
}
